type PostReactionEvent = { memberId: string; emoji: string; removed: boolean };
type Listener = (e: PostReactionEvent) => void;

const listeners = new Map<string, Set<Listener>>();

export function subscribePostReaction(
  postId: string,
  fn: Listener,
): () => void {
  let set = listeners.get(postId);
  if (!set) {
    set = new Set();
    listeners.set(postId, set);
  }
  set.add(fn);

  return () => {
    const current = listeners.get(postId);
    if (!current) return;
    current.delete(fn);
    if (current.size === 0) listeners.delete(postId);
  };
}

export function emitPostReaction(postId: string, e: PostReactionEvent): void {
  const set = listeners.get(postId);
  if (!set) return;
  set.forEach((fn) => fn(e));
}
